import { Fragment } from 'react'
import { useTheme } from '@opallabs/hooks'
import { Modal } from '@opallabs/lapidary'
import { ShortcutList } from '@opallabs/satellite'
import { shortcutMap } from './shortcutMap'
import * as styles from './styles'

type ShortcutModalProps = {
  setShowShortcuts: (show: boolean) => void
  showShortcuts: boolean
}

export const ShortcutModal: React.FC<ShortcutModalProps> = ({
  setShowShortcuts,
  showShortcuts,
}) => {
  const theme = useTheme()

  return (
    <Fragment>
      <div
        role="presentation"
        css={
          showShortcuts && [
            styles.overlayOverrides,
            styles.overlayOverridesDynamic({ theme }),
          ]
        }
        onClick={() => setShowShortcuts(false)}
      />
      <Modal.Root open={showShortcuts} onOpenChange={setShowShortcuts}>
        <Modal.Content
          onEscapeKeyDown={(e) => {
            e.stopPropagation()
            setShowShortcuts(false)
          }}
          onPointerDownOutside={() => setShowShortcuts(false)}
          css={styles.contentOverrides}
          scrollable
        >
          <Modal.Title>Text Editor Keyboard Shortcuts</Modal.Title>
          <Modal.Close />
          <Modal.Body style={styles.bodyOverrides}>
            <ShortcutList
              css={styles.shortcutListOverrides}
              shortcutMap={shortcutMap}
            />
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>
    </Fragment>
  )
}
